<template>
  <div ref="pageContainer" class="page-container">
    <!-- 轮播图 -->
    <div class="banner">
      <el-image :src="bannerImage">
        <div slot="placeholder" style="width: 100%; height: 300px;">

        </div>
      </el-image>
    </div>

    <!-- 主页内容 -->
    <div class="content-container">
      <div class="content-navigate">
        <!-- 网点导航 -->
        <div class="tip-container">
          <blockquote class="el-blockquote">
            信用报告查询网点导航
          </blockquote>
          <router-link to="/questionAnswer" class="tip-action-button" @click.native.stop>
            <el-image :src="robotImg" alt="Chat" class="tip-chat-icon">
              <div slot="placeholder" class="image-slot">

              </div>
            </el-image>
          </router-link>
        </div>
        <router-link to="/navigate" class="image-link" @click="setActiveNavItem('/navigate')">
          <el-image :src="navigationImg" alt="Navigate Image" class="navigate-image">
            <div slot="placeholder" style="width: 100%; height: 138px;">

            </div>
          </el-image>
        </router-link>
      </div>

      <div class="content-channel">
        <!-- 查询渠道 -->
        <blockquote class="el-blockquote">
          信用报告查询渠道
        </blockquote>
        <el-row type="flex" justify="space-between">
          <router-link
            v-for="item in facilityChannel"
            :key="item.index"
            :to="item.url"
            class="image-link"
          >
            <el-image :src="item.img" :class="item.class">
              <div slot="placeholder" style="width: 190px; height: 135px;">

              </div>
            </el-image>
          </router-link>
        </el-row>
      </div>

      <div class="content-publicize">
        <!-- 宣传栏 -->
        <blockquote class="el-blockquote">
          征信知识宣传栏
        </blockquote>
        <el-row type="flex" justify="space-around">
          <div class="content-publicize_left">
            <div v-for="item in creditKnowledgeBarConfig" :key="item.index" class="image-link">
              <el-image
                v-if="item.className === 'content-publicize_left'"
                :src="item.image"
                class="centered-image"
                @click="toPage(item)"
              >
                <div slot="placeholder" style="width: 133px; height: 228px;">

                </div>
              </el-image>
            </div>
          </div>
          <div class="content-publicize_right">
            <div v-for="item in creditKnowledgeBarConfig" :key="item.index" class="image-link">
              <el-image
                v-if="item.className === 'content-publicize_right'"
                :src="item.image"
                class="centered-image"
                @click="toPage(item)"
              >
                <div slot="placeholder" style="width: 247px; height: 67px;">

                </div>
              </el-image>
            </div>
          </div>
        </el-row>
      </div>
      <el-dialog
        :visible.sync="isNoticeDialogVisible"
        width="90%"
        @close="isNoticeDialogVisible = false"
      >
        <div class="dialog-content">
          <div v-for="(item, index) in notices" :key="index">
            <h4 class="notice-title" v-html="item.title || ''" />
            <div v-html="item.content || ''" />
          </div>
        </div>
        <div class="divider" />
        <span slot="footer">
          <el-button class="confirm-button" size="small" @click="isNoticeDialogVisible = false">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import axios from 'axios'

export default {
  data() {
    return {
      isNoticeDialogVisible: false,
      notices: [],
      showFontSizeOptions: false,
      selectedFontSize: '小',
      fontSizeOptions: ['小', '中', '大'],
      bannerImage: require('@/assets/lunbo/lunbo03_01.jpg'),
      // 自动切换的时间间隔，单位为毫秒
      interval: 10000,
      arrow: 'never',
      // 导航图片
      navigationImg: require('@/assets/wangdian.png'),
      robotImg: require('@/assets/icon_robot.png'),
      // 网点渠道
      facilityChannel: [
        {
          index: 0,
          url: '/perQuery',
          img: require('@/assets/chaxun_01.png'),
          class: 'centered-image'
        },
        {
          index: 1,
          url: '/entQuery',
          img: require('@/assets/chaxun_02.png'),
          class: 'centered-image'
        }
      ],
      creditKnowledgeBarConfig: [
        {
          index: 0,
          columnName: '征信小知识',
          image: require('@/assets/xiaozhishi.png'),
          className: 'content-publicize_left'
        },
        {
          index: 1,
          columnName: '中小微企业资金流信用信息共享平台',
          image: require('@/assets/fuwu_01.png'),
          className: 'content-publicize_right'
        },
        {
          index: 2,
          columnName: '中征应收账款融资服务平台',
          image: require('@/assets/fuwu_02.png'),
          className: 'content-publicize_right'
        },
        {
          index: 3,
          columnName: '动产融资统一登记公示系统',
          image: require('@/assets/fuwu_03.png'),
          className: 'content-publicize_right'
        }
      ]
    }
  },
  created() {
    const hasVisited = sessionStorage.getItem('hasVisited')

    if (!hasVisited) {
      this.getNotice()
      sessionStorage.setItem('hasVisited', true)
    }
    window.addEventListener('beforeunload', this.clearSession)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.clearSession)
    window.removeEventListener('resize', this.checkAndroidNavigationBar)
  },
  mounted() {
    // this.checkAndroidNavigationBar()
    window.addEventListener('resize', this.checkAndroidNavigationBar)
    // 初始化字体设置
    const savedFontSize = localStorage.getItem('fontSize') || '中'
    this.selectedFontSize = savedFontSize
    document.documentElement.style.setProperty('--home-title-font-size', this.getTitleFontSize(savedFontSize))
    document.documentElement.style.setProperty('--home-font-size', this.getFontSize(savedFontSize))
    document.documentElement.style.setProperty('--home-height', this.getHomeHeight(savedFontSize))
    document.documentElement.style.setProperty('--line-height', this.getLineHeight(savedFontSize))
  },
  methods: {
    ...mapMutations(['setActiveNavItem']),
    /**
     * 跳转到详情页面
     */
    toPage(item) {
      this.$router.push({
        name: 'columnItemList',
        query: {
          columnName: item.columnName
        }
      })
    },
    getNotice() {
      axios.post(this.$config.baseUrl + '/appointment-web/noticeController/getNotice')
        .then(response => {
          this.notices = response.data.notice
          if (this.notices.length > 0) {
            this.isNoticeDialogVisible = true
          }
        })
        .catch(error => {
          console.error('Error sending POST request:', error)
        })
    },
    clearSession() {
      sessionStorage.removeItem('hasVisited')
    },
    checkAndroidNavigationBar() {
      const pageContainer = this.$refs.pageContainer
      const isAndroid = /android/i.test(navigator.userAgent)
      const hasNavigationBar = window.innerHeight !== screen.height

      if (isAndroid && hasNavigationBar) {
        const navigationBarHeight = window.innerHeight - screen.availHeight
        const newHeight = window.innerHeight - navigationBarHeight

        pageContainer.querySelector('.content-container').style.height = `${newHeight}px`
      } else {
        pageContainer.querySelector('.content-container').style.height = '75%'
      }
    },
    handleScreenClick(event) {
      // 检查点击的目标是否是字体设置抽屉中的元素
      const clickedElement = event.target
      const isInDrawer = clickedElement.closest('.font-size-options')

      // 如果点击的是字体设置选项或复制链接，则不切换抽屉显示状态
      if (isInDrawer || clickedElement.classList.contains('copy-link')) {
        return
      }

      // 切换字体设置抽屉的显示状态
      this.showFontSizeOptions = !this.showFontSizeOptions
    },
    changeFontSize(size) {
      this.selectedFontSize = size
      document.documentElement.style.setProperty('--home-title-font-size', this.getTitleFontSize(size))
      document.documentElement.style.setProperty('--home-font-size', this.getFontSize(size))
      document.documentElement.style.setProperty('--home-height', this.getHomeHeight(size))
      document.documentElement.style.setProperty('--line-height', this.getLineHeight(size))
      // 保存字体设置到 localStorage
      localStorage.setItem('fontSize', size)
    },
    getTitleFontSize(size) {
      switch (size) {
        case '小':
          return '14px'
        case '中':
          return '16px'
        case '大':
          return '18px'
        default:
          return '14px'
      }
    },
    getFontSize(size) {
      switch (size) {
        case '小':
          return '13px'
        case '中':
          return '15px'
        case '大':
          return '17px'
        default:
          return '13px'
      }
    },
    getLineHeight(size) {
      switch (size) {
        case '小':
          return '1.6'
        case '中':
          return '1.8'
        case '大':
          return '2.0'
        default:
          return '1.6'
      }
    },
    getHomeHeight(size) {
      switch (size) {
        case '小':
          return '3%'
        case '中':
          return '4%'
        case '大':
          return '5%'
        default:
          return '3%'
      }
    }
  }
}
</script>

<style scoped>
:root {
  --home-title-font-size: 14px;
  --home-font-size: 13px;
  --home-height: 3%;
  --font-size: 16px;
  --line-height: 1.6;
}

.page-container {
  position: relative;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.el-blockquote {
  border-left: 3px solid;
  border-image: linear-gradient(to bottom, #357bf0, #6a9ef4) 1;
  font-size: var(--home-title-font-size, 14px);
  line-height: 24px;
  padding-left: 10px;
  text-align: left;
  text-decoration: none;
  color: #000000;
  font-weight: bold;
  margin: 2% 0 2% 2%;
}

.image-link {
  text-decoration: none;
  outline: none;
  border: none;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.content-publicize {
  padding-bottom: 2%;
}

.centered-image {
  width: 95%;
  border-radius: 10px;
}

.content-publicize_left {
  width: 35%;
}

.content-publicize_right {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-content: center;
  gap: 6.5%;
  width: 65%;
}

.navigate-image {
  max-width: 100%;
  width: 98%;
}

.notice-title {
  text-align: center;
}

::v-deep .el-dialog__body {
  padding: 0 20px 10px 20px !important;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid blue;
  margin: 0 20px;
  padding: 40px 0 10px 0;
}

.dialog-content {
  height: 400px;
}

::v-deep .el-dialog__footer {
  text-align: center !important;
}

.confirm-button {
  color: blue;
}

.content-container {
  height: 75%;
  margin: 0 auto;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
}

.divider {
  height: 1px;
  background-color: #ddd;
  margin: 0 15px;
}

.font-size-options {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.font-size-label {
  font-size: 16px;
  margin-bottom: 10px;
  text-align: left;
  padding-left: 10px;
}

.font-size-options-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
}

.font-size-option {
  font-size: 16px;
  padding: 10px 20px;
  cursor: pointer;
  border: 2px solid transparent;
}

.font-size-option.selected {
  border-color: black;
}

.slide-up-enter-active, .slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter, .slide-up-leave-to {
  transform: translateY(100%);
}

.tip-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tip-action-button {
  right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  z-index: 10;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
}

.tip-chat-icon {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.tip-vertical-text {
  font-size: 12px;
  color: #409EFF;
  white-space: nowrap;
  writing-mode: vertical-rl;
  text-align: center;
  line-height: 1.2;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
